import { startsWithValidCharacter } from './entity-ids'

/**
 * Fixes question IDs from before engine v1.14, and the references to them.
 */
export interface LegacyIdFixer {
  /**
   * Fixes the ID a question declares, and makes it unique.
   */
  declare(id: string | undefined): string | undefined

  /**
   * Fixes a reference to a question, without reserving the ID.
   */
  resolve(id: string): string
  resolve(id: string | undefined): string | undefined
  resolve(id: string | null | undefined): string | null | undefined
}

/*
  Since engine v1.14, every entity with an ID must have a globally unique ID
  that satisfies the entity ID format. Older legends may not, so IDs are fixed
  when loading, and the next publish saves the fixed IDs without breaking
  versions that are already deployed.
*/

/**
 * Creates a fixer for the IDs of one legend.
 */
export function createLegacyIdFixer(): LegacyIdFixer {
  const used = new Set<string>()

  function resolve(id: string): string
  function resolve(id: string | undefined): string | undefined
  function resolve(id: string | null | undefined): string | null | undefined
  function resolve(id: string | null | undefined) {
    if (!id) {
      return id
    }
    return startsWithValidCharacter(id) ? id : `Q_${id}`
  }

  const declare = (id: string | undefined) => {
    const resolved = resolve(id)
    if (!resolved) {
      return resolved
    }
    let count = 1
    let next = resolved
    while (used.has(next)) {
      count++
      next = `${resolved}_${count}`
    }
    used.add(next)
    return next
  }

  return { declare, resolve }
}
